import { GetterTree } from "vuex";
import { CompanyState } from "./types";
import { RootState } from "../../types";

export const getters: GetterTree<CompanyState, RootState> = {};
